import {
  AgeStep,
  MarriageStep,
  DependentsStep,
  EmploymentStatusStep,
  LivingSituationStep,
  IncomeStep,
  NonRetirementSavingsStep,
  RetirementSavingsStep,
  HomeValueStep,
  MortgageStep,
  OwnACarStep,
  AutoInsuranceStep,
  AutoInsuranceDetailsStep,
  HomeOwnersInsuranceStep,
  RentersInsuranceStep,
  HomeownersInsuranceDetails,
  RentersInsuranceDetailsStep,
  HealthInsuranceStep,
  HighDeductiblePlanStep,
  HealthInsuranceDetailsStep,
  LifeInsuranceStep,
  LifeInsuranceTypeStep,
  LifeInsuranceDetailsStep,
  DisabilityInsuranceStep,
  DisabilityInsuranceTypeStep,
  DisabilityInsuranceDetailsStep,
  LongTermCareInsuranceStep,
  UmbrellaInsuranceStep,
  UmbrellaInsuranceDetailsStep,
  IdentityTheftProtectionStep,
  IdentityTheftProtectionDetailsStep,
  LastWillStep,
  LastWillStateStep,
  LastWillDetailsStep,
  CreditReportStep,
  SeparateInsurancePoliciesStep,
  UserInformationStep,
  GetMyResultsStep,
} from './components/steps';

export const stepMap = {
  AgeStep,
  MarriageStep,
  DependentsStep,
  EmploymentStatusStep,
  LivingSituationStep,
  IncomeStep,
  NonRetirementSavingsStep,
  RetirementSavingsStep,
  HomeValueStep,
  MortgageStep,
  OwnACarStep,
  AutoInsuranceStep,
  AutoInsuranceDetailsStep,
  HomeOwnersInsuranceStep,
  RentersInsuranceStep,
  HomeownersInsuranceDetails,
  RentersInsuranceDetailsStep,
  HealthInsuranceStep,
  HighDeductiblePlanStep,
  HealthInsuranceDetailsStep,
  LifeInsuranceStep,
  LifeInsuranceTypeStep,
  LifeInsuranceDetailsStep,
  DisabilityInsuranceStep,
  DisabilityInsuranceTypeStep,
  DisabilityInsuranceDetailsStep,
  LongTermCareInsuranceStep,
  UmbrellaInsuranceStep,
  UmbrellaInsuranceDetailsStep,
  IdentityTheftProtectionStep,
  IdentityTheftProtectionDetailsStep,
  LastWillStep,
  LastWillStateStep,
  LastWillDetailsStep,
  CreditReportStep,
  SeparateInsurancePoliciesStep,
  UserInformationStep,
  GetMyResultsStep,
};

export type StepName = keyof typeof stepMap;
